import VideoIframe from 'client/common/components/video-iframe';

import './index.css';

export default VideoIframe;
